import { doPost } from '../fetch';

const addUserToWaitlist = async (user) => {
  const saveToWaitlist = await doPost(`/b2c/sendgrid/add-contact`, user);
  return saveToWaitlist;
};

export { addUserToWaitlist };
